export { default } from './NavFeatured';
